<template>
  <div>
    <div class="panel-heading d-flex align-center py-2">
      <h4 class="panel-title">{{ $t('mobileApp.linksTitle') }}</h4>

      <div style="text-align: end">
        <v-btn
          v-if="$_has_perm('add_link_rule')"
          color="primary"
          style="height: auto;"
          depressed
          @click="addNew()"
        >
          {{ $t('datatable.addNewButton') }}
        </v-btn>
      </div>
    </div>

    <div class="panel-body">
      <v-layout
        row
        wrap
      >
        <v-flex
          sm12
          md4
          lg3
          xl3
          class="px-3"
        >
          <v-text-field
            v-model="queryParams.keyword"
            :label="$t('linkRules.searchByNameOrDomainPlaceholder')"
            @keypress.enter="getData()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t('columns.name') }}</th>
              <th>{{ $t('columns.domain') }}</th>
              <th>{{ $t('linkRules.shortLinkColumn') }}</th>
              <th>{{ $t('linkRules.priorityColumn') }}</th>
              <th>{{ $t('common.active') }}</th>
              <th>{{ $t('columns.createdAt') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data, index) in apiData"
              :key="index"
            >
              <td>{{ data.name }}</td>
              <td>{{ data.domain }}</td>
              <td>
                <v-chip
                  small
                  :color="data.is_short_link ? 'blue lighten-4' : 'grey lighten-3'"
                >
                  {{ data.is_short_link ? $t('common.yes') : $t('common.no') }}
                </v-chip>
              </td>
              <td>{{ data.priority }}</td>
              <td>
                <v-chip
                  small
                  :color="data.is_active ? 'green lighten-4' : 'red lighten-4'"
                >
                  {{ data.is_active ? $t('common.active') : $t('common.inactive') }}
                </v-chip>
              </td>
              <td>{{ data.created_at | moment('YYYY-MM-DD hh:mm a') }}</td>
              <td>
                <a
                  v-if="$_has_perm('edit_link_rule')"
                  :tooltip="$t('common.edit')"
                  @click="editRow(data)"
                >
                  <v-icon color="blue darken-2">edit</v-icon>
                </a>
                <a
                  v-if="$_has_perm('delete_link_rule')"
                  :tooltip="$t('common.delete')"
                  @click="deleteRow(data.link_rule_id)"
                >
                  <v-icon color="red darken-2">delete</v-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <add-edit
      :addEditModal="addEditModal"
      :form="form"
      :isUpdate="isUpdate"
      @close="addEditModal = false"
      @resetTable="getData()"
    />
  </div>
</template>

<script>
import Axios from 'axios'
import addEdit from './addEdit.vue'
import swal from 'sweetalert'

export default {
  components: { addEdit },
  data() {
    return {
      apiData: [],
      addEditModal: false,
      isUpdate: false,
      form: {},
      queryParams: {
        keyword: null
      }
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    addNew() {
      this.isUpdate = false
      this.form = {
        name: null,
        domain: null,
        is_short_link: false,
        product_page_match_type: null,
        product_page_pattern: null,
        exclude_path_prefixes: null,
        name_extract_match_type: null,
        name_extract_pattern: null,
        name_cleanup_regex: null,
        priority: 100,
        is_active: true,
        notes: null
      }
      this.addEditModal = true
    },

    editRow(data) {
      this.form = { ...data }
      this.isUpdate = true
      this.addEditModal = true
    },

    deleteRow(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          Axios.delete(`api/link-rule/${id}`, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
            this.getData()
            swal({
              title: this.$t('common.deletedSuccessfully'),
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          }).catch((error) => {
            swal(this.$t('common.error'), error.response.data.message, 'error')
          })
        }
      })
    },

    getData() {
      var token = localStorage.getItem('access_token')

      Axios.get('api/link-rule', { params: this.queryParams, headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.apiData = res.data
      })
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  border-radius: 3px;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/linkRules/linkRules.vue